module.exports = __webpack_public_path__ + "static/media/signal-alt-3.0b7ef18a.svg";